import { CommonLocalStorageKeyEnum } from 'Feature/Common/Common/Types/Enums/CommonLocalStorageKeyEnum';
import LabelValueType from 'Shared/Core/Common/Models/LabelValueType';
import { Storage } from 'Shared/Utils/LocalStorage/Storage';

export default class GeneralConfigs extends Storage<CommonLocalStorageKeyEnum, LabelValueType> {
  private static instance?: GeneralConfigs;

  private constructor() {
    super();
  }

  public static getInstance() {
    if (!this.instance) {
      this.instance = new GeneralConfigs();
    }

    return this.instance;
  }

  public getGeneralConfigs(): LabelValueType[] {
    const result = this.get(CommonLocalStorageKeyEnum.GENERAL_CONFIGS);
    if (Array.isArray(result)) return result;
    else return [];
  }

  public getGeneralConfigsWithExpiry(): LabelValueType[] {
    const result = this.getWithExpire(CommonLocalStorageKeyEnum.GENERAL_CONFIGS);
    if (Array.isArray(result)) return result;
    else return [];
  }

  public setGeneralConfigs(generalConfigs: LabelValueType[]): void {
    this.set(CommonLocalStorageKeyEnum.GENERAL_CONFIGS, generalConfigs);
  }

  public setGeneralConfigsWithExpiry(generalConfigs: LabelValueType[], expiry: Date): void {
    this.setWithExpire(CommonLocalStorageKeyEnum.GENERAL_CONFIGS, generalConfigs, expiry);
  }

  public clear(): void {
    this.clearItems([CommonLocalStorageKeyEnum.GENERAL_CONFIGS]);
  }

  public generalConfigsHasValue(): boolean {
    return this.hasValue(CommonLocalStorageKeyEnum.GENERAL_CONFIGS);
  }

  public generalConfigsIsExpire(): boolean {
    const isExpire = this.isExpire(CommonLocalStorageKeyEnum.GENERAL_CONFIGS);
    if (isExpire) this.clear();
    return isExpire;
  }
}
